// Lightweight geo distance - no external library. Used by the NOW feed to show
// "how far away" each located item is from the viewer (computed once per load).

import i18n from './i18n'

const EARTH_RADIUS_M = 6371000

function toRad(deg) {
  return (deg * Math.PI) / 180
}

// Great-circle distance in meters between two lat/lng points (haversine).
export function haversineMeters(lat1, lng1, lat2, lng2) {
  const dLat = toRad(lat2 - lat1)
  const dLng = toRad(lng2 - lng1)
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2
  return 2 * EARTH_RADIUS_M * Math.asin(Math.min(1, Math.sqrt(a)))
}

// "300 m" under 1 km; "1.2 km" at/above 1 km (one decimal, the UI language's separator: "1,2 km" in fr/vi/de…).
export function formatDistance(meters) {
  if (meters < 1000) return `${Math.round(meters)} m`
  return `${new Intl.NumberFormat(i18n.language, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(meters / 1000)} km`
}
